import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  StorylineSettingsLoadFulfilledAction,
  StorylineSettingsLoadPendingAction,
  StorylineSettingsLoadRejectedAction,
} from '../../domains/storylineSettings/actions.types';

import type { StorylineSettingsLifecycle } from './types';

export type StorylineSettingsAction =
  | StorylineSettingsLoadPendingAction
  | StorylineSettingsLoadRejectedAction
  | StorylineSettingsLoadFulfilledAction;

const initialState: StorylineSettingsLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<StorylineSettingsLifecycle, StorylineSettingsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'STORYLINE_SETTINGS.LOAD_PENDING':
      return setPending();
    case 'STORYLINE_SETTINGS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'STORYLINE_SETTINGS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    default:
      return state;
  }
};

export default reducer;
